class LogoList extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.logo-list-track');
    if (!this.track) return;

    this.mediaQuery = window.matchMedia('(max-width: 767px)');
    this.handleChange = () => this.syncClones();
    this.mediaQuery.addEventListener('change', this.handleChange);
    this.syncClones();
  }

  disconnectedCallback() {
    this.mediaQuery?.removeEventListener('change', this.handleChange);
  }

  syncClones() {
    if (this.mediaQuery.matches) {
      if (this.track.dataset.cloned === 'true') return;
      const originals = Array.from(this.track.children);
      originals.forEach((node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.clone = 'true';
        this.track.appendChild(clone);
      });
      this.track.dataset.cloned = 'true';
    } else {
      if (this.track.dataset.cloned !== 'true') return;
      this.track.querySelectorAll('[data-clone="true"]').forEach((n) => n.remove());
      delete this.track.dataset.cloned;
    }
  }
}

customElements.define('logo-list', LogoList);
